import React from 'react'
import { NavLink } from 'react-router-dom'

const menus = [
  {name:'Home', path:'/'},
  {name:'Project', path:'/gallery'},
  {name:'Service', path:'/services'},
  {name:'Brands', path:'/product'},
  {name:'Article', path:'/articles'},
  {name:'Request', path:'/Request'}
]

const NavbarMobile = ({isOpen, closeMenu}) => {
  return (
    <div
      className={`
      md:hidden fixed top-[72px] left-0 w-full bg-white shadow-xl
      transition-all duration-300 ease-in-out z-[998]
      ${isOpen
        ? 'translate-y-0 opacity-100'
        : '-translate-y-full opacity-0 pointer-events-none'}
      `}
    >
      <div className="px-6 py-8 flex flex-col gap-2">

        {menus.map((item)=>(
          <NavLink
            key={item.name}
            to={item.path}
            onClick={closeMenu}
            className={({isActive}) =>
              `
              group relative px-4 py-3 rounded-xl
              font-medium transition-all duration-300
              ${isActive
                ? 'bg-primary text-white'
                : 'text-primary hover:bg-gray-100'}
              `
            }
          >
            <span className="relative z-10">
              {item.name}
            </span>
          </NavLink>
        ))}

        <a
          href="https://api.whatsapp.com/send?phone=6289507085550"
          target="_blank"
          rel="noopener noreferrer"
          className="
          mt-4
          inline-flex
          self-start
          px-4 py-2
          text-sm
          rounded-full
          border border-primary
          text-primary
          hover:bg-primary
          hover:text-white
          duration-300
          "
        >
          Contact Us
        </a>

      </div>
    </div>
  )
}

export default NavbarMobile